import { NgModule } from '@angular/core';

import { AssessmentsRoutingModule } from './assessments-routing.module';
import { CoreModule } from 'src/app/core/core.module';
import { RequetsModule } from '../requets/requets.module';
import { AssignEvaluatorComponent } from './assign-evaluator/assign-evaluator.component';
import { AssesmentsService } from './shared/assesments.service';
import { AssignSingleEvaluatorComponent } from './assign-single-evaluator/assign-single-evaluator.component';
import { AssessmentsEvaluatorComponent } from './assessments-evaluator/assessments-evaluator.component';
import { AssessmentsComponent } from './assessments.component';
import { AssessComponent } from './assess/assess.component';
import { RequestDetailEvaluatorComponent } from './request-detail-evaluator/request-detail-evaluator.component';
import { ChangeVersionDialogComponent } from './change-version-dialog/change-version-dialog.component';
import { MoreDetailDialogComponent } from './more-detail-dialog/more-detail-dialog.component';
import { EvaluateRequestComponent } from './evaluate-request/evaluate-request.component';
import { SubjectEvaluateComponent } from './subject-evaluate/subject-evaluate.component';
import { SubjectEvaluateSelectedComponent } from './subject-evaluate-selected/subject-evaluate-selected.component';
import { SavedEvaluationComponent } from './saved-evaluation/saved-evaluation.component';
import { DefermentCriteriaComponent } from './deferment-criteria/deferment-criteria.component';
import { SubjectsCriteriaComponent } from './subjects-criteria/subjects-criteria.component';
import { SelectPeriodDialogComponent } from './select-period-dialog/select-period-dialog.component';

@NgModule({
  imports: [
    CoreModule,
    RequetsModule,
    AssessmentsRoutingModule
  ],
  declarations: [AssignEvaluatorComponent, AssignSingleEvaluatorComponent,
    AssessmentsEvaluatorComponent, AssessmentsComponent, AssessComponent,
    RequestDetailEvaluatorComponent, ChangeVersionDialogComponent, MoreDetailDialogComponent,
    EvaluateRequestComponent, SubjectEvaluateComponent, SubjectEvaluateSelectedComponent,
    SavedEvaluationComponent, DefermentCriteriaComponent, SubjectsCriteriaComponent, SelectPeriodDialogComponent],
  providers: [AssesmentsService],
  entryComponents: [ChangeVersionDialogComponent, MoreDetailDialogComponent, SelectPeriodDialogComponent],
  exports: [RequetsModule, AssignEvaluatorComponent, AssignSingleEvaluatorComponent,
    AssessmentsEvaluatorComponent, AssessmentsComponent, AssessComponent,
    RequestDetailEvaluatorComponent, ChangeVersionDialogComponent, MoreDetailDialogComponent,
    EvaluateRequestComponent, SubjectEvaluateComponent, SubjectEvaluateSelectedComponent,
    SavedEvaluationComponent, DefermentCriteriaComponent, SubjectsCriteriaComponent, SelectPeriodDialogComponent]
})
export class AssessmentsModule { }
